import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Editor, useEditorState } from '@tiptap/react';
import { FC } from 'react';
import { MdFormatBold, MdFormatItalic } from 'react-icons/md';

interface ToolbarProps {
  editor: Editor | null;
}

export const RichTextToolbar: FC<ToolbarProps> = ({ editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor: ed }) => {
      if (!ed) {
        return { isBoldActive: false, isItalicActive: false, canBold: false, canItalic: false };
      }
      return {
        isBoldActive: ed.isActive('bold'),
        isItalicActive: ed.isActive('italic'),
        canBold: ed.can().chain().toggleBold().run(),
        canItalic: ed.can().chain().toggleItalic().run(),
      };
    },
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Tooltip title="Bold">
        <span>
          <IconButton
            size="small"
            onMouseDown={e => {
              e.preventDefault();
              editor.chain().focus().toggleBold().run();
            }}
            disabled={!editorState.canBold}
            color={editorState.isBoldActive ? 'primary' : 'default'}
            aria-label="Bold"
          >
            <MdFormatBold size={18} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Italic">
        <span>
          <IconButton
            size="small"
            onMouseDown={e => {
              e.preventDefault();
              editor.chain().focus().toggleItalic().run();
            }}
            disabled={!editorState.canItalic}
            color={editorState.isItalicActive ? 'primary' : 'default'}
            aria-label="Italic"
          >
            <MdFormatItalic size={18} />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
